import { createThreadBehaviour } from './shared-responder-v2-core-thread-behaviour';
import {
  createChoiceEmptyDraft,
  isChoiceContinueButtonVisible,
  isChoiceDraftComplete,
  reduceChoiceDraft,
} from './shared-responder-v2-core-thread-choice';
import { THREAD_KINDS } from './shared-responder-v2-core-thread.consts';

/**
 * Same draft/selection/Continue rules as `choice` — an image option is just a
 * tile instead of a text label. The shared capability table already gives
 * `imageChoice` its own `supportsOther: false`, since image options have no
 * "Other" tile to select.
 */
export const IMAGE_CHOICE_THREAD_BEHAVIOUR = createThreadBehaviour({
  kind: THREAD_KINDS.ImageChoice,
  advancesOnSurfacePick: true,
  spokenAffordances: { extractsSpokenPick: true },
  emptyDraft: createChoiceEmptyDraft,
  reduceDraft: reduceChoiceDraft,
  isDraftComplete: isChoiceDraftComplete,
  showsContinueButton: isChoiceContinueButtonVisible,
});
